'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'sailboat';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e445';
var svgPathData = ['M51.8 416l408.4 0-32 64-344.4 0-32-64zM96 304l128-170.7 0 170.7-128 0zM256 94.7L415.4 304 256 304 256 96c0-.4 0-.8 0-1.3z', 'M256 94.7L415.4 304 256 304 256 96c0-.4 0-.8 0-1.3zM256 336l224 0-24.4-32-199.6-262-32-42 0 80-192 256 192 0 0 48-224 0 64 128 384 0 64-128-256 0 0-48zm-32-32L96 304 224 133.3 224 304zM51.8 416l408.4 0-32 64-344.4 0-32-64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSailboat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;